export const body = () => ({
    overflow: 'hidden',
});
